import { StarIcon } from "@heroicons/react/16/solid";
import { FieldValues, RegisterOptions, useFormContext } from "react-hook-form";

interface ITextAreaProps {
  containerClass?: string;
  label: string;
  registerOptions?: RegisterOptions<FieldValues, string>;
  name: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

function TextArea({
  containerClass,
  label,
  registerOptions,
  name,
  className,
  placeholder,
  disabled,
}: ITextAreaProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = String(errors[name]?.message) || "";

  return (
    <div className={`flex flex-col w-full ${containerClass}`}>
        {label && (
        <label className="text-xs flex items-center gap-1 text-left text-body font-semibold pl-1">
          {label}
          {registerOptions?.required && (
            <StarIcon className="size-2 text-error -translate-y-1" />
          )}
        </label>
      )}
      <section className="w-full relative">
        <textarea
          placeholder={placeholder}
          disabled={disabled}
          {...register(name, registerOptions)}
          autoComplete="off"
          className={`h-10 w-full text-sm 
              text-body font-semibold px-2 py-1 placeholder:font-medium placeholder:text-darkGray/80 outline-none 
               z-10 bg-offWhite/80 rounded-lg ${
                 error ? "border-error" : "border-extraLightGray "
               }
              disabled:bg-gray-200 disabled:cursor-not-allowed
              ${className}`}
        />
      </section>
      {error !== "undefined" ? (
        <p className="text-xs text-error/90 font-medium pl-1 ">{error}</p>
      ) : (
        <></>
      )}
    </div>
  );
}

export default TextArea;
